import React from "react";
import { Link } from "react-router-dom";
import "../assets/css/sidemenu.css";
import { Menubar } from "primereact/menubar";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

function TopMenu() {

  const navigate = useNavigate();

  const itemRenderer = (item) => (
    <Link
      to={item.link}

      style={{ textDecoration: "none" }}
    >
      <i className={`${item.icon} me-2`} style={{color: "#333"}} />
      <span className="mx-0" style={{textDecoration: "none",color: "#333"}}>
        {item.label}
      </span>
    </Link>
  );

  const itemRenderer1 = (item) => (
    <Link
      to={item.link}

      style={{ textDecoration: "none", paddingLeft: "10px", paddingRight: '10px' }}
    >
      <i className={`${item.icon} me-2`} style={{color: "#333"}} />
      <span className="inline-flex align-items-center gap-1 px-2 py-2" style={{textDecoration: "none",color: "#333"}}>
        {item.label}
      </span>
    </Link>
  );
  const items = [
    {
          label: "Home",
          link: "/Pages/Home",
          icon: "pi pi-home",
          template: itemRenderer1,
        },
    {
          label: "Firm Clients",
          link: "/Pages/FirmClients",
          icon: "pi pi-users",
          template: itemRenderer1,
      },
      {
          label: "Messages",
          link: "/Pages/Messages",
          icon: "pi pi-envelope",
          template: itemRenderer1,
        },
      {
          label: "Generate CUD ORDS Scripts",
          link: "/Pages/GenerateCUDORDS",
          icon: "pi pi-bolt",
          template: itemRenderer1,
        },
  ];

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login")
  }

  const confirmLogout = () => {
    confirmDialog({
      message: "Are you sure want to logout?",
      header: "Logout Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: handleLogout,
    })
  }
  const logoutButton = (
    <Button label="Logout" icon="pi pi-sign-out" onClick={confirmLogout} />
  )

  return (
  <>
  <ConfirmDialog />
  <Menubar model={items} end={logoutButton} />
  </>
  );
}

export default TopMenu;


